import { css } from '@emotion/react';
import { isFunction } from 'lodash-es';
import { CreatePaymentIntentBody } from '@frontend/api-weave-pay';
import { formatCentsToCurrency } from '@frontend/currency';
import { Trans, useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, Heading, Text } from '@frontend/design-system';
import successGraphic from './assets/success-state.png';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    border: 1px solid ${theme.colors.neutral20};
    box-shadow: ${theme.shadows.light};
    border-radius: ${theme.borderRadius.small};
    padding: ${theme.spacing(0.5)} ${theme.spacing(3)} ${theme.spacing(1)};
    width: 545px;
    height: min-content;
  `,
  buttonMargin: css`
    margin-bottom: ${theme.spacing(2)};
    align-self: center;
  `,
};

interface SuccessCardProps {
  payment: Pick<CreatePaymentIntentBody, 'person' | 'amount'>;
  onClick?: () => void;
}

export const SuccessCard = ({ payment, onClick }: SuccessCardProps) => {
  const { t } = useTranslation('weave-pay');
  const { amount, person } = payment;
  const fullName = [person?.firstName, person?.lastName].join(' ').trim();

  return (
    <div css={styles.container}>
      <Heading textAlign='center' level={3}>
        {t('Payment Successfully Submitted!')}
      </Heading>
      <img src={successGraphic} alt='success graphic' />
      <div>
        {!!amount && (
          <Text>
            <Trans t={t}>
              A payment of {formatCentsToCurrency(amount)} has been submitted {fullName && `for ${fullName}'s card.`}
            </Trans>
          </Text>
        )}
        {person?.email && <Text>{t(`An email receipt has been sent to ${person?.email}`)}</Text>}
      </div>
      {isFunction(onClick) && (
        <Button variant='primary' onClick={onClick} css={styles.buttonMargin}>
          {t('Make another payment')}
        </Button>
      )}
    </div>
  );
};
